import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { Redirect, withRouter, RouteComponentProps } from "react-router-dom";
import * as Cookies from "universal-cookie";
import { ToastContainer, toast } from "react-toastify";
import { IToken, IUser } from '@nkr/models/index';
import { IApplicationState, IAppState, AppActionCreators, IAuthState, AuthActionCreators, IAuthCheck } from '@nkr/store/index';
import { LoadingIndicator } from "./loading-indicator";

interface IOwnProps extends RouteComponentProps<{ centerId: string }> { }

interface IStateProps {
    app: IAppState
    auth: IAuthState,
}

interface IDispatchProps {
    storeAuth: (token: IToken, tokenHex: string) => void,
    validToken: () => boolean,
    setUserProfile: (user: IUser) => void,
    refreshToken: () => Promise<IAuthCheck>,
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    authorizationChecked: boolean;
    redirectToLogin: boolean;
    showSessionDialog: boolean;
    minutesRemaining: number;
    centerAlias: string
}

const initialState: IState = {
    authorizationChecked: false,
    redirectToLogin: false,
    showSessionDialog: false,
    minutesRemaining: 0,
    centerAlias: ""
}

class Print extends React.Component<TProps, IState> {
    readonly state: IState = initialState;
    timer: any;
    sessionStart: any;
    hasCenterAlias: boolean;

    componentWillMount() {
        var cookies = new Cookies();
        var nkrAuth = cookies.get("NkrAuth");
        var nkrSession = cookies.get("NkrSession");
        var redirect = false;

        if (nkrAuth != null) {
            var { token, user } = nkrAuth;

            if (this.props.auth.isAuthenticated || nkrAuth != null) {
                this.props.storeAuth(token, nkrSession);

                if (this.props.validToken()) {
                    if (this.props.app.user == null) {
                        if (user != null) {
                            this.props.setUserProfile(user);

                            if (user.centerAlias)
                                this.hasCenterAlias = true;
                        }
                    }
                } else {
                    redirect = true;
                }
            } else {
                redirect = true;
            }
        } else {
            redirect = true;
        }

        if (redirect)
            this.setState({
                redirectToLogin: true
            });
    }

    componentDidMount() {    }

    public render() {
        const currentUrl = this.props.location.pathname + encodeURIComponent(this.props.location.search);

        if (this.state.redirectToLogin)
            return <Redirect to={"/login?next=" + currentUrl} />;

        return (
            <div>
                <LoadingIndicator
                    type="spin"
                    color="black"
                    loading={this.props.app.loading}
                    message={this.props.app.loadingMessage}
                />

                <div className='container-fluid'>
                    <div className="row">
                        <div className="col-xs-12">
                            {this.props.children}

                            <ToastContainer
                                position={toast.POSITION.TOP_CENTER}
                                autoClose={2000}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app,
        auth: state.auth
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        storeAuth: (token, tokenHex) => { dispatch(AuthActionCreators.storeAuth(token, tokenHex)); },
        validToken: () => { return dispatch(AuthActionCreators.validToken()); },
        setUserProfile: (user) => { dispatch(AppActionCreators.setUserProfile(user)); },
        refreshToken: () => { return dispatch(AuthActionCreators.refreshToken()); }
    };
}

export default withRouter(connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Print));
